import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Alert, Backdrop, Button, CircularProgress, Snackbar } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDetalleCategoria, postAddCategoria, postUpdateCategoria } from "../../../../api/ApiService";



function AddObsequioCategoriaPage() {
    const [cargando, setCargando] = useState(false);
    const [descripcion, setDescripcion] = useState('');
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loadingGuardar, setLoadingGuardar] = useState(false);


    const params = useParams();
    const { id } = params;
    console.log("id", id);
    // console.log("params", localizacion);

    const navigate = useNavigate();

    const stateToken = useSelector(state => state.reducerGlobal.token);

    useEffect(() => {
        if (id) {
            if (stateToken) {
                handleDetalleEvento();
            }
        } else {
            setTimeout(() => {
                setCargando(true);
            }, 1000);
        }
    }, [id, stateToken]);



    //==========================================================funcion para enviar encuesta a la api
    const handleDetalleEvento = () => {
        getDetalleCategoria(id, stateToken?.access_token)
            .then(response => {
                console.log("getDetalleCategoria", response);
                setCargando(true);
                setDescripcion(response?.data?.nombre);

            })
            .catch(error => {
                console.log("error-getDetalleCategoria", error);
                setCargando(false);

                setMensaje("Error al cargar los datos");
                setSeverity('error');
                setOpen(true);
            })
    }


    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };

    //=========================================================funcion para cancelar y volver a la lista
    const handleCancelar = () => {
        window.history.back();
    };

    //=========================================================funcion para guardar
    const handleGuardar = () => {
        let body = {};
        body.nombre = descripcion;

        console.log("body", body);

        //validar campos que no esten vacios
        if (descripcion.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('Todos los campos son obligatorios');
        } else {

            setLoadingGuardar(true);

            handleAddCategoriaApi(body);
        }
    };

    //=========================================================api de crear categoria
    const handleAddCategoriaApi = (body) => {

        postAddCategoria(body, stateToken?.access_token)
            .then((response) => {
                console.log("response-postAddCategoria", response);
                setLoadingGuardar(false);

                setOpen(true);
                setSeverity('success');
                setMensaje('Guardado con exito');
                setTimeout(() => {
                    navigate('/app/admin/obsequios/categorias');
                }, 1200);

                setDescripcion('');



            })
            .catch((error) => {
                console.log("error-postAddCategoria", error);
                setLoadingGuardar(false);

                setOpen(true);
                setSeverity('error');
                setMensaje('Error al guardar la categoria');

                setTimeout(() => {
                    setOpen(false);
                }, 2000);
            });
    };


    //=========================================================funcion para guardar
    const handleGuardarUpdate = () => {
        let body = {};
        body.nombre = descripcion;

        console.log("body", body);

        //validar campos que no esten vacios
        if (descripcion.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('Todos los campos son obligatorios');
        } else {

            setLoadingGuardar(true);

            handleUpdateCategoriaApi(body);
        }
    };

    //=========================================================api de actualizar categoria
    const handleUpdateCategoriaApi = (body) => {

        postUpdateCategoria(id, body, stateToken?.access_token)
            .then((response) => {
                console.log("response-postUpdateCategoria", response);
                setLoadingGuardar(false);

                setOpen(true);
                setSeverity('success');
                setMensaje('Guardado con exito');
                setTimeout(() => {
                    navigate('/app/admin/obsequios/categorias');
                }, 1200);
            })
            .catch((error) => {
                console.log("error-postUpdateCategoria", error);
                setLoadingGuardar(false);

                setOpen(true);
                setSeverity('error');
                setMensaje('Error al guardar la categoria');

                setTimeout(() => {
                    setOpen(false);
                }, 2000);
            });
    };




    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="max-w-5xl mx-auto">
                    <div className="mb-6">
                        <h1 className="text-2xl font-bold text-gray-800 mb-1">
                            {id ? 'Editar Categoría' : 'Nueva Categoría'}
                        </h1>
                    </div>

                    {cargando ? (
                        <div className="bg-white rounded-xl shadow-xl overflow-hidden p-6">
                            <div className="w-full max-w-2xl">
                                <label className="block text-sm font-medium text-gray-700 mb-2">Descripcion</label>
                                <input
                                    type="text"
                                    value={descripcion}
                                    onChange={(e) => setDescripcion(e.target.value)}
                                    autoCapitalize="none"
                                    autoCorrect="off"
                                    placeholder="Ingrese una descripcion"
                                    className="w-full px-3 py-2 rounded-lg bg-[#f1f5f9] border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
                                />

                                <div className="flex justify-start gap-3 pt-6 border-t border-gray-200 mt-6">
                                    <button
                                        type="button"
                                        disabled={loadingGuardar}
                                        onClick={() => id ? handleGuardarUpdate() : handleGuardar()}
                                        className="px-6 py-2 bg-[#104063] hover:bg-[#0d3553] disabled:opacity-70 text-white rounded-lg font-medium transition-colors"
                                    >
                                        {loadingGuardar ? "Guardando..." : "Guardar"}
                                    </button>

                                    <button
                                        type="button"
                                        onClick={handleCancelar}
                                        className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) :
                        (
                            <div className="bg-white rounded-xl shadow-md p-8">
                                <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                                <div className="space-y-4">
                                    <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                    <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                    <div className="h-24 bg-gray-200 rounded animate-pulse" />
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default AddObsequioCategoriaPage;